import { cn } from '../cn.js';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** What is loading, for assistive technology. Defaults to a generic message. */
  label?: string;
}

/**
 * A placeholder for content that is loading.
 *
 * It announces itself once rather than animating silently, and it stops animating when the person
 * has asked for reduced motion.
 */
export function Skeleton({ className, label = 'Loading', ...props }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn(
        'animate-pulse rounded-(--radius-md) bg-(--color-surface-sunken)',
        'motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  );
}
